import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@root/src/environments/environment';

/** One row of GET /orchestration/worker-tags. */
export interface WorkerTagDto {
  name: string;
}

/**
 * Worker capability tag catalog.
 * TODO: migrate to api-client when WorkerTagController is generated.
 */
@Injectable({ providedIn: 'root' })
export class WorkerTagsService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.api}/orchestration/worker-tags`;

  list(): Observable<WorkerTagDto[]> {
    return this.http.get<WorkerTagDto[]>(this.url);
  }

  create(name: string): Observable<WorkerTagDto> {
    return this.http.post<WorkerTagDto>(this.url, { name });
  }

  delete(name: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${encodeURIComponent(name)}`);
  }
}
